import axios from 'axios';

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async getPermissionsProject(context, data = {}) {
      try {
        const config = { withCredentials: true };
        const permissions = await axios.get(`/autodesk/bim-360/document-management/permissions/${data.projectId}/folder/${data.folderId}/permissions`, config);
        return permissions.data;
      } catch (error) {
        throw error;
      }
    },
    async addPermissionsProject(context, data = {}) {
      try {
        const config = { withCredentials: true };
        const projectRoles = await axios.post(`/autodesk/bim-360/document-management/permissions/${data.projectId}/folder/${data.folderId}/permissions:batch-create`, data.permissions, config);
        return projectRoles.data;
      } catch (error) {
        throw error;
      }
    },
    async updatePermissionsProject(context, data = {}) {
      try {
        const config = { withCredentials: true };
        const projectRoles = await axios.post(`/autodesk/bim-360/document-management/permissions/${data.projectId}/folder/${data.folderId}/permissions:batch-update`, data.permissions, config);
        return projectRoles.data;
      } catch (error) {
        throw error;
      }
    },
    async deletePermissionsProject(context, data = {}) {
      try {
        const config = { withCredentials: true };
        const projectRoles = await axios.post(`/autodesk/bim-360/document-management/permissions/${data.projectId}/folder/${data.folderId}/permissions:batch-delete`, data.permissions, config);
        return projectRoles.data;
      } catch (error) {
        throw error;
      }
    },
  },
};
